import React from 'react';

const VodOverlay = ({ vod }) => {
  const { title, rated, link } = vod;

  return (
    <div className="movie-poster--details">
      <h4 className="movie-poster--title">
        <a className="movie-poster--link" href={link}>
          {title}
        </a>
      </h4>
      {rated && (
        <ul className="movie-attributes">
          <li>
            <i className="icon-fsk"></i> FSK: {rated}
          </li>
        </ul>
      )}
      <a
        href={link}
        target="_blank"
        className="btn btn__primary inverse movie-poster--tickets"
      >
        Mehr
      </a>
    </div>
  );
};

export default VodOverlay;
